import { BaseLayoutOptions, CytoscapeOptions } from 'cytoscape';

import { Theme } from '@/controllers';

export const getAnchorIDFromCohortType = (cohortType: string): string =>
  `cohort-${cohortType.toLowerCase()}`;

export const nodeBackgroundColor = '#D8A0F7';
export const nodeBackgroundColorHover = '#AF59E1';

export const getCytoscapeConfig = (
  theme: Theme,
  maxNodeLabelLength?: number
): CytoscapeOptions => ({
  style: [
    {
      selector: 'node',
      style: {
        'background-color': nodeBackgroundColor,
        label: 'data(label)',
        'text-valign': 'top',
        'text-halign': 'center',
        'text-margin-y': -10,
        'font-size': '11px',
        'font-weight': 'bold',
        'overlay-opacity': 0,
        color: theme === Theme.Dark ? '#B6C2CF' : '#44546f',
        width: 25,
        height: 25,
      },
    },
    {
      selector: 'edge',
      style: {
        'curve-style': 'bezier',
        'target-arrow-shape': 'triangle',
        'target-arrow-color': theme === Theme.Dark ? '#B6C2CF' : '#44546f',
        'line-color': theme === Theme.Dark ? '#B6C2CF' : '#44546f',
        width: 2,
      },
    },
  ],
  layout: {
    name: 'dagre',
    rankDir: 'LR',
    rankSep:
      maxNodeLabelLength && maxNodeLabelLength > 10 ? 100 + 2 * (maxNodeLabelLength - 10) : 100,
    nodeSep: 60,
    edgeSep: 60,
    ranker: 'network-simplex',
    fit: false,
  } as BaseLayoutOptions,
  userPanningEnabled: false,
  userZoomingEnabled: false,
  boxSelectionEnabled: false,
  zoomingEnabled: false,
  autoungrabify: true,
});
